var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      ref: "popover",
      attrs: { placement: "top", width: "600", trigger: "click" },
      on: { show: _vm.onPopupShow },
    },
    [
      _c(
        "note-form",
        _vm._b(
          {
            key: _vm.formKey,
            ref: "form",
            attrs: { "can-set-read-only-note": _vm.canSetReadOnlyNote },
            on: { stored: _vm.onStored, cancel: _vm.onCancel },
          },
          "note-form",
          _vm.formData,
          false
        )
      ),
      _vm._v(" "),
      _vm._t("default", null, { slot: "reference" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }